import { useContext } from 'react';

import { DevModalContext, type DevModalContextType } from '../DevModalProvider';

/**
 * Hook to access dev modal functionality from components.
 */
export const useDevModal = (): DevModalContextType => {
  const context = useContext(DevModalContext);

  if (!context) {
    // Return default values when not within provider context
    return {
      isDevModalOpen: false,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      openDevModal: () => {},
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      closeDevModal: () => {},
      shouldShowDevButton: false,
      devFlagOverrideKey: 0,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      registerDevFlagListener: () => () => {}, // Return a no-op unregister function
    };
  }

  return context;
};
